import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "main-container mt-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  class: "single-line-label",
  for: "name"
}, "Proje Adı ", -1)
const _hoisted_3 = {
  class: "single-line-label mb-5",
  for: "logo"
}
const _hoisted_4 = {
  key: 1,
  class: "flex gap-8"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-8 mb-4 text-3xl font-semibold" }, "Üniteler", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl italic" }, [
  /*#__PURE__*/_createTextVNode(" Kullanım verilerinin otomatik olarak hesaplanabilmesi için, ünite isimlerinin "),
  /*#__PURE__*/_createElementVNode("strong", null, "birebir Excel dosyalarında gözüktüğü şekilde"),
  /*#__PURE__*/_createTextVNode(" girilmesi gerekmektedir. Ünite isimlerini manuel olarak girebilir veya hata olmaması için herhangi bir aya ilişkin ACP raporu yükleyebilirsiniz. ")
], -1)
const _hoisted_8 = { class: "flex my-4" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = {
  key: 0,
  class: "flex my-34"
}
const _hoisted_12 = {
  key: 1,
  class: "w-full flex gap-4"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "ac-primary-button text-2xl mr-8"
}, "Proje Oluştur", -1)

import { reactive, computed, ref, onBeforeMount } from 'vue';
import VueTooltip from '../reusable/VueTooltip.vue';
import fileUploadFlexible from '../reusable/fileUploadFlexible.vue';
import multipleObjectInput from '../reusable/multipleObjectInput.vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import {createUnitNamesFromExcel, createOrEditProject, getOMProject,} from '@/composables/omPlatformFunctions';
import bmsMethods from "../../mixins/bms/bmsMethods";


export default /*#__PURE__*/_defineComponent({
  __name: 'omProjectForm',
  setup(__props) {

const existingProjectID = ref<string | undefined>(undefined)

const store = useStore();
const route = useRoute();
const router = useRouter();

const isCalculatingUnitNames = ref(false)
const isChangingLogo = ref(false)
const userName = computed(() => store.getters["user/userProfile"].name)

// const unitDefinition = reactive({})

const project = reactive({
    name: "",
    logoURL: "",
    unitArrayInputType: "automatic",
    units: [],
    editedBy: userName.value,
})

const createOMProject = async () => {
    try {
        await createOrEditProject(project, existingProjectID.value ? existingProjectID.value : undefined)
        router.push('/om-platform/projects');
    } catch (error) {
        alert(`Proje oluşturulurken bir hata oluştu. Lütfen bu mesajı yazılım ekibiniz ile paylaşın: ${error}`)
    }

}

const goBack = () => {
    router.push('/om-platform/omProjects');
}

const uploadLogo = async (file: File[]) => {
    const logoUrl = await bmsMethods.methods.uploadSingleToBMS(file[0], 'logos/',  false)
    project.logoURL = logoUrl
    isChangingLogo.value = false
}

const fetchUnitNamesFromExcel = async (file: File[]) => {
    isCalculatingUnitNames.value = true
    const units = await createUnitNamesFromExcel(file[0], 1)
    project.units = units
    isCalculatingUnitNames.value = false
}

onBeforeMount( async () => {
    // Get the project id from the route, if any
    if(route.query.id){
        const routeProject = await getOMProject(route.query.id as string)
        existingProjectID.value = route.query.id as string
        if(routeProject){
            project.name = routeProject.name
            project.logoURL = routeProject.logoURL
            project.unitArrayInputType = routeProject.unitArrayInputType
            project.units = routeProject.units
        }
    }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "dashboard-form",
      onSubmit: _withModifiers(createOMProject, ["prevent"])
    }, [
      _hoisted_2,
      _withDirectives(_createElementVNode("input", {
        required: "",
        type: "text",
        id: "name",
        class: "dashboard-form__input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((project.name) = $event))
      }, null, 512), [
        [_vModelText, project.name]
      ]),
      _createElementVNode("label", _hoisted_3, [
        _createTextVNode("Proje Logosu "),
        _createVNode(VueTooltip, { explanation: "Buradan projenin kendi logosunu veya projeye özel bir logo yoksa şirket logosunu yükleyebilirsiniz. Logo seçmemeniz durumunda varsayılan proje logo görseli kullanılacaktır." }, {
          default: _withCtx(() => [
            _createTextVNode("?")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([project.logoURL === '' ? 'items-stretch' : 'items-end', "w-full"])
      }, [
        (project.logoURL === '' || isChangingLogo.value)
          ? (_openBlock(), _createBlock(fileUploadFlexible, {
              key: 0,
              onFilesChanged: uploadLogo,
              "single-file": true
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("img", {
                src: project.logoURL,
                class: "w-20 h-20"
              }, null, 8, _hoisted_5),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (isChangingLogo.value = true)),
                type: "button",
                class: "ac-secondary-button"
              }, "Değiştir")
            ]))
      ], 2),
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (project.units = [])),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((project.unitArrayInputType) = $event)),
            class: "flex text-xl mr-3 dashboard-form__input-radio",
            type: "radio",
            id: "automatic",
            name: "automatic",
            value: "automatic"
          }, null, 512), [
            [_vModelRadio, project.unitArrayInputType]
          ]),
          _createElementVNode("label", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (project.units = [])),
            class: "text-2xl mr-7",
            for: "automatic"
          }, "Ünite isimleri dosyadan alınsın.")
        ]),
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (project.units = [])),
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((project.unitArrayInputType) = $event)),
            class: "flex text-xl mr-3 dashboard-form__input-radio",
            type: "radio",
            id: "manual",
            name: "manual",
            value: "manual"
          }, null, 512), [
            [_vModelRadio, project.unitArrayInputType]
          ]),
          _createElementVNode("label", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (project.units = [])),
            class: "text-2xl",
            for: "manual"
          }, "Ünite isimlerini manuel olarak gireceğim.")
        ])
      ]),
      (project.units.length > 0 || project.unitArrayInputType === 'manual')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(multipleObjectInput, {
              "initial-value": project.units,
              onUpdateSelectedOptions: _cache[8] || (_cache[8] = ($event: any) => (project.units = $event)),
              "object-key": "Ünite",
              "object-value": "Kapasite"
            }, null, 8, ["initial-value"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (isCalculatingUnitNames.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Ünite isimleri alınıyor, lütfen bekleyin..."))
              : (!isCalculatingUnitNames.value && project.units.length < 1)
                ? (_openBlock(), _createBlock(fileUploadFlexible, {
                    key: 1,
                    class: "w-full flex",
                    onFilesChanged: _cache[9] || (_cache[9] = ($event: any) => (fetchUnitNamesFromExcel($event))),
                    "single-file": true
                  }))
                : _createCommentVNode("", true)
          ])),
      _createElementVNode("div", { class: "flex justify-center items-center mt-8" }, [
        _hoisted_14,
        _createElementVNode("button", {
          type: "button",
          onClick: goBack,
          class: "ac-secondary-button text-2xl"
        }, "Vazgeç")
      ])
    ], 32)
  ]))
}
}

})